export const RRS_NOMINAL_AND_EFFECTIVE_INTEREST_RATE = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Nominell og effektiv rente – hva er forskjellen?',
  url: 'https://scoopr.no/nominell-og-effektiv-rente-hva-er-forskjellen',
  description:
    'Alle som søker om lån ønsker seg så lav rente som mulig. Men det er fort gjort å la seg lure, for rente er ikke bare rente. Det kan være store forskjeller på den effektive og den nominell renten – vi forteller deg hvordan du unngår å gå i rentefellen.',
  datePublished: '2022-02-17T08:00:00+00:00',
  dateModified: '2022-02-17T08:00:00+00:00',
};
